module.exports = __webpack_public_path__ + "static/media/contact_banner.c9a9e2f0.png";